import { PageTitle } from '@oysterjs/ui/page';
import { PageOutlet } from '@oysterjs/ui/navigation';
import { libraryPage, usePageHeading } from '~/components/navigation';

export const LibraryPage = () => {
  const { title, description } = usePageHeading(libraryPage);

  return (
    <PageTitle eyebrow={libraryPage.name} title={title} description={description}>
      <PageOutlet />
    </PageTitle>
  );
};
